module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/4/2-ccf916f32b8170bc761c24111f14eb0b.jpg";